module.exports = __webpack_public_path__ + "static/media/likes.1fbe3ddc.svg";